module.exports = __webpack_public_path__ + "static/instagram-c75c9652bc56853eeb9c5f5e58431292.png";